import { render } from "./OrganizationsFilter.vue?vue&type=template&id=20556d16&scoped=true"
import script from "./OrganizationsFilter.vue?vue&type=script&lang=js"
export * from "./OrganizationsFilter.vue?vue&type=script&lang=js"

import "./OrganizationsFilter.vue?vue&type=style&index=0&id=20556d16&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20556d16"]])

export default __exports__